<template>
  <div v-if="functionInputList">
    <v-text-field
      v-if="!hideSearch"
      label="Filter"
      v-model="search"
      outlined
      class="mt-5"
    ></v-text-field>
    <v-data-table
      :headers="headers"
      :items="list"
      :search="search"
      class="och-table pb-2"
      disable-pagination
      hide-default-footer
      sort-by="name"
    >
      <template v-slot:no-data>
        <i>No functions created or associated</i>
      </template>
      <template v-slot:item="{ item }">
        <tr
          v-if="item"
          @click="
            $router.push({
              name: 'ochinUserSecurityFunctionForm',
              params: {
                functionId: item.secFunctionId,
              },
            })
          "
          class="och-tableRow"
        >
          <td>{{ item.name }}</td>
          <td>
            <div
              v-for="(input, index) in filterFunctionInput(
                'secFunctionId',
                item.secFunctionId
              )"
              :key="`${item.id}_${index})_type`"
              class="mt-2"
            >
              {{ input.type }}
            </div>
          </td>
          <td>
            <div
              v-for="(input, index) in filterFunctionInput(
                'secFunctionId',
                item.secFunctionId
              )"
              :key="`${item.id}_${index})_point`"
              class="mt-2"
            >
              {{ input.point }}
            </div>
          </td>
          <td>
            <div
              v-for="(input, index) in filterFunctionInput(
                'secFunctionId',
                item.secFunctionId
              )"
              :key="`${item.id}_${index})_value`"
              class="mt-2"
            >
              <span v-if="item.inverted"
                >{{ input.operator }}
                <v-chip class="ml-2" x-small label pill>Inverted</v-chip></span
              >
              <span v-else>{{ input.operator }}</span>
            </div>
          </td>
          <td>
            <div
              v-for="(input, index) in filterFunctionInput(
                'secFunctionId',
                item.secFunctionId
              )"
              :key="`${item.id}_${index})_value`"
              class="mt-2"
            >
              {{ input.value }}
            </div>
          </td>
          <td class="text-right">
            <v-btn
              outlined
              small
              class="mr-3"
              color="primary"
              @click.stop="toggleInvertedFunction(item)"
              >{{ item.inverted ? "Revert" : "Invert" }}</v-btn
            >
            <v-btn
              v-if="showRemoveButton"
              @click.stop="removeFunction(item)"
              color="primary"
              outlined
              small
            >
              Remove
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  computed: {
    showRemoveButton() {
      return !!this.$listeners.remove;
    },
    ...mapGetters({
      filterFunctionInput: "secFunctionInput/filterByAttributeValue",
      filterType: "epicApplicationType/filterByAttributeValue",
      getTypeById: "epicApplicationType/getById",
    }),
    ...mapState({
      functionInputList: state => state.secFunctionInput.list,
    }),
  },
  async created() {
    await Promise.all([
      this.getAnswerFunctionList(),
      this.getFunctionInputList(),
    ]);
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "name",
          align: "start",
        },
        {
          text: "Type",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "Item",
          value: "point",
          align: "start",
          sortable: false,
        },
        {
          text: "Operator",
          value: "operator",
          align: "start",
          sortable: false,
        },
        {
          text: "Value",
          value: "value",
          align: "start",
          sortable: false,
        },
        {
          text: " ",
          value: "",
          align: "start",
          sortable: false,
        },
      ],
      search: null,
    };
  },
  methods: {
    navigate(name, params) {
      this.$emit("navigate", { name, params });
    },
    removeFunction(item) {
      this.$emit("remove", item);
    },
    async toggleInvertedFunction(item) {
      const invertedValue = item.inverted === 1 ? 0 : 1;
      await this.updateAnswerFunction([item.id, { inverted: invertedValue }]);
    },
    ...mapActions({
      getAnswerFunctionList: "secAnswerSecFunction/list",
      getFunctionInputList: "secFunctionInput/list",
      updateAnswerFunction: "secAnswerSecFunction/update",
    }),
  },
  props: ["hideSearch", "list"],
};
</script>
